/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from "styled-components";
import { mediaHelperMaxWidth } from "../../../../utils/src";
import Colors from 'constants/Colors';
import Label from 'components/Form/Label';
import { FontWeight, Text } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";

export const ViewText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ left }) => left ? 'flex-start' : 'flex-end'};
  align-items: center;
  margin-bottom: 10px;
  
  
  ${mediaHelperMaxWidth.md`
      justify-content: flex-start;
  `}
`;


export const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;


  ${mediaHelperMaxWidth.sm`
    flex-direction: column;
    align-items: center;
  `}
`;

export const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  justify-content:space-evenly;
  background-color:#FFF;
  
  ${mediaHelperMaxWidth.sm`
    margin-top: 10px;
    width: 100%
  `}
`;

export const Label1 = styled(Label)`
  color: ${Colors.GRAY[0]};
  font-weight: ${FontWeight.Bold};
  font-size: 14px;
`;

export const RadioContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 18px 0;
  
  width: ${props => props.width ? `${props.width}%` : '80%'};

  

  @media screen and (max-width: 751px) {
    width: 100%;
    flex-direction: column;
  } 

  

`;

export const Line = styled.div`
  width: 98%;
  height: 1px !important;
  background-color:#C0C0C0;
  margin: 10px auto;
`;


export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
`

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`

export const TableRow = styled.tr`

`;


export const TableHeader = styled.th`
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}px` : ''}
  ${({ maxWidth }) => maxWidth ? `width: ${maxWidth}px` : ''}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  span {
    font-size: 13px !important;
  }
`

export const TableBody = styled.tbody`
    tr {
      border-bottom: 2px solid #E0E0E0;
    }
`;

export const TableLineCheckbox = styled.div`
display: flex;

   
`;

export const TableCollum = styled.td`
  vertical-align: top;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  padding-bottom: 8px;
  padding-top: 8px;
  padding-right: 5px;
  display: table=cell;

  &:last-child {
    padding-right: 0px;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;
    text-align: left;
    width: 100%;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;

export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: 600px) {
    display: none;
  }
`;

export const DialogIcon = styled.div`
    height: 30px;
    display: inline;
    margin-right: 5px;
    width: 100%;
    ${({ pink }) =>
    pink == "exclamation"
      ? css`
          color: ${Colors.PINK};
          `
      : `display: ${Colors.BLACK};`
  }
    
    font-size: 22px;
    svg{
      float: left;
    }
`;

export const TextTitle = styled(Text)`
  ${({ size }) => size ? `font-size: ${size}px` : '12px'}
  font-weight: 600;
  font-family: 'FiraSans', sans-serif;
  color: #53565A;

`;


export const CalendarContainer = styled.div`
  position: absolute;
  margin: 4px;
  z-index: 55;
  top: 60px;
  right: 24px;
`;



export const ContentTextarea = styled.div`
  width: 100%;  
  
  p {
    color: ${Colors.GRAY[0]};
    margin-bottom: 5px;
    margin-top: 10px;
    font-weight: 800;
    font-size: 14px; 
  }
`;


export const ButtonContainerRow = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0;

  ${mediaHelperMaxWidth.sm`
    flex-direction: column;
    align-items: center;
  `}
`;


export const LabelEdit = styled(Label)`

  @media screen and (max-width: ${Breakpoints.sm}) {
    width: unset;
    text-align: center;
  } 
  
`;

export const MarginDiv = styled.div`
    @media screen and (max-width: 751px) {
      margin-top: 12px;
  } 
`;

export const YearMonthSelect = styled.select`
  border-radius: 10px;
  border-color: #5C078C;
  font-size: 15px;
  padding: 0 5px 0 5px;
  margin: 0 5px 0 5px;
`;

export const BorderSwitch = styled.div`  
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  height: 30px;
  display: -webkit-inline-box;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;